<div class="login-page">
  <!-- Gradient background for mobile view only -->
  <div class="gradient-background-mobile">
    <div class="gradient-ellipse ellipse-1"></div>
    <div class="gradient-ellipse ellipse-2"></div>
    <div class="gradient-ellipse ellipse-3"></div>
  </div>

  <!-- Gradient background for desktop view only -->
  <div class="gradient-background-desktop">
    <div class="gradient-ellipse-desktop ellipse-desktop-1"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-2"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-3"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-4"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-5"></div>
    <div class="gradient-ellipse-desktop ellipse-desktop-6"></div>
  </div>

  <div class="login-header">
    <img class="brand-logo" src="/assets/images/Logo.png" alt="McCain Logo">
    <div class="title">DIGITAL PASSPORT</div>
    <div class="subtitle">Please sign in to view your <strong>Digital Passport</strong></div>
  </div>

  <!-- Logout message banner -->
  <div class="logout-message" *ngIf="logoutMessage()">
    {{ logoutMessage() }}
  </div>

  <div class="login-form">
    <button 
      type="button" 
      class="proceed-button" 
      [disabled]="isSubmitting()"
      (click)="onProceedToSSO()">
      <span *ngIf="isSubmitting()">Loading...</span>
      <span *ngIf="!isSubmitting()">Sign In with Single Sign On</span>
    </button>
  </div>
</div>
